import * as React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        link: {
            display: 'flex',
            alignItems: 'center',
        },
        image: {
            maxWidth: '100%',
            height: 'auto',
            maxHeight: '48px',
        },
    }),
);

export interface AppLogoProps {
    logoImg?: string;
    logoUrl?: string;
}

export const AppLogo: React.FC<AppLogoProps> = ({ logoImg, logoUrl }) => {
    const classes = useStyles();

    if (!logoImg) { return <div />; }

    return (
        <a className={classes.link} target="_blank" rel="noopener noreferrer" href={logoUrl}>
            <img className={classes.image} src={logoImg} />
        </a>
    );
};
